class SecondaryDropdown extends window.BAO.CustomElement({
  SuperClass: HTMLDetailsElement,
}) {
  static get requiredExternalElements () {
    return ['container']
  }

  static get requiredElements () {
    return ['dropdown']
  }

  connectedCallback () {
    super.connectedCallback()

    this.position()
  }

  setupListeners () {
    super.setupListeners()

    this.close = this.close.bind(this)
    this.closeOthers = this.closeOthers.bind(this)

    this.listeners.add(document.body, 'click', this.close)
    this.listeners.add(this, 'toggle', this.closeOthers)
  }

  close (e) {
    if (!this.isOpen) return
    if (e.target.closest(this.localName)) return

    this.removeAttribute('open')
  }

  closeOthers () {
    if (!this.isOpen) return

    const otherOpenSecondaryNavigations = window.BAO.Utils.getElements(
      `${this.localName}[open]`,
    ).filter(el => el !== this)
    if (otherOpenSecondaryNavigations.length === 0) return

    otherOpenSecondaryNavigations.forEach(el => el.removeAttribute('open'))
  }

  position () {
    const containerBoundingRect = this.externalEls.container.element.getBoundingClientRect()

    const containerFromRight =
      window.innerWidth -
      (containerBoundingRect.x + containerBoundingRect.width)
    const dropdownFromRight =
      window.innerWidth -
      (this.dropdownBoundingRect.x + this.dropdownBoundingRect.width)

    const amountToShift = dropdownFromRight - containerFromRight

    this.els.dropdown.element.style.setProperty(
      '--Arrow_Left',
      `${negateNumber(amountToShift)}px`,
    )
    this.els.dropdown.element.style.setProperty(
      '--Left_Addition',
      `${amountToShift}px`,
    )
  }

  /**
   * This will not work in Safari or Firefox unless the details is open. This is because the offsetParent is null unless it's open. So, to get it, we temporarily open it, grab it, shut it.
   */
  get dropdownBoundingRect () {
    this.open = true
    const dropdownBoundingRect = this.els.dropdown.element.getBoundingClientRect()
    this.open = false

    return dropdownBoundingRect
  }

  get isOpen () {
    return this.hasAttribute('open')
  }
}

if (!customElements.get('secondary-dropdown')) {
  customElements.define('secondary-dropdown', SecondaryDropdown, {
    extends: 'details',
  })
}

function negateNumber (number) {
  if (number < 0) {
    return Math.abs(number)
  }

  return -Math.abs(number)
}
